export const FACTION_VENTORY_ADDITIONAL_GUILD_INCOME = 1;
export const FACTION_VENTORY_ADDITIONAL_TEMPLE_INCOME = 1;
export const FACTION_VENTORY_BUILDING_ROAD_COINS_DISCOUNT = 1;